// extracted by mini-css-extract-plugin
export var card = "_qw-0";
export var content = "_qw-2";
export var details = "_qw-3";
export var icon = "_qw-1";
export var iconBlue = "_qw-5";
export var iconBrand = "_qw-4";
export var iconGrayBlue = "_qw-6";
export var iconGreen = "_qw-7";
export var iconIndigo = "_qw-8";
export var iconOrange = "_qw-9";
export var iconPurple = "_qw-a";
export var iconRed = "_qw-b";
export var iconWarning = "_qw-c";